import { Percent } from '@kodiak-finance/sdk-core'

import {
  ALLOWED_PRICE_IMPACT_HIGH,
  ALLOWED_PRICE_IMPACT_LOW,
  ALLOWED_PRICE_IMPACT_MEDIUM,
  BLOCKED_PRICE_IMPACT_NON_EXPERT,
  PRICE_IMPACT_WITHOUT_FEE_CONFIRM_MIN,
} from '../constants/misc'

const IMPACT_TIERS = {
  LOW: ALLOWED_PRICE_IMPACT_LOW, // 1%
  MEDIUM: ALLOWED_PRICE_IMPACT_MEDIUM, // 3%
  HIGH: ALLOWED_PRICE_IMPACT_HIGH, // 5%
  CONFIRM: PRICE_IMPACT_WITHOUT_FEE_CONFIRM_MIN, // 10%
  BLOCKED: BLOCKED_PRICE_IMPACT_NON_EXPERT, // 15%
}

type WarningSeverity = 0 | 1 | 2 | 3 | 4 | 5

export function warningSeverity(priceImpact: Percent | null): WarningSeverity {
  if (!priceImpact) return 4

  if (priceImpact.greaterThan(new Percent(0))) {
    return 0
  }

  const impactMagnitude = priceImpact.multiply(-1)

  if (impactMagnitude.lessThan(IMPACT_TIERS.LOW)) {
    return 1 // < 1% - Very low impact
  }

  if (impactMagnitude.lessThan(IMPACT_TIERS.MEDIUM)) {
    return 2 // 1-3% - Low impact
  }

  if (impactMagnitude.lessThan(IMPACT_TIERS.HIGH)) {
    return 3 // 3-5% - Medium impact
  }

  if (impactMagnitude.lessThan(IMPACT_TIERS.CONFIRM)) {
    return 4 // 5-10% - High impact (warning)
  }

  // 10% and above - Show error
  return 5 // >= 10% - Critical impact (error/blocked)
}
